import { useTranslation } from "react-i18next"
import { Banner } from "@/components/ui/banner"

type TeleGpOnboardingBannerProps = {
  show: boolean
}

export const TeleGpOnboardingBanner = ({ show }: TeleGpOnboardingBannerProps) => {
  const { t } = useTranslation()

  if (!show) {
    return null
  }

  return <Banner data-testid="first-contact-tele-gp-banner">{t("patient.teleGpOnboarding.banner")}</Banner>
}
